"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
exports.default = (0, react_1.css) `
    .question_type_clickmapVideo .attachment-video
    {
        margin: 0 auto;
    }

    .question-video
    {
        overflow: hidden;
        position: relative;
        padding-bottom: 51.25%;
        margin-top: -51.25%;
        height: 0;
    }
    .question-video__click-area
    {
        top: 0;
        bottom: 0;
        position: absolute;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        /* z-index: 10; */
        background: rgba(0, 0, 0, 0.1);
        box-sizing: border-box;
    }

    .question-video__after
    {
        font-family: var(--main-font);
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;

        height: 100%;
        width: 100%;
        bottom: 0;
        top: 0;
        z-index: 1;
        color: white;
        font-size: 20px;
        background: rgba(0, 0, 0, 0.85);
        user-select: none;
    }

    .question_type_clickmapVideo .attachment:before
    {
        border: 3px solid transparent;
    }
    .question_type_clickmapVideo.question_pressed .attachment:before
    {
        border-color: #FFCC00;
        display: block;
        content: '';
        pointer-events: none;
        user-select: none;
        position: absolute;
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        z-index: 1;
    }

    .button.button_view_normal.question-video__hold-button
    {
        font-family: var(--main-font);
        margin-top: 24px;
        width: 100%;
        height: 60px;
        line-height: 60px;
        box-sizing: border-box;

        border-radius: 8px;
        border: 2px dashed #C5C5C5;
        background: transparent;
    }


    .question-video__hold-button .button__text {
        height: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .question-video__hold-button .button__text:before
    {
        background-image: url("data:image/svg+xml,%3Csvg width='16' height='22' viewBox='0 0 16 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.459 7.72709C13.1637 7.72709 12.8437 7.77631 12.5977 7.89935C12.3516 7.1611 11.6872 6.66893 10.8997 6.61971C10.5306 6.5705 10.186 6.66893 9.86613 6.8658C9.54622 6.32441 9.00483 5.95529 8.34041 5.90607C8.09432 5.90607 7.84824 5.95529 7.60215 6.02911V4.18348C7.60215 3.14993 6.81468 2.28863 5.83035 2.1902C5.28896 2.14098 4.79679 2.36246 4.42767 2.68237C4.05854 3.05149 3.83706 3.54366 3.83706 4.03583V11.0738L3.29568 10.5817C2.43438 9.84342 1.5977 9.72038 0.90866 10.1387C0.465708 10.3848 0.170407 10.8031 0.0473645 11.3445C-0.0756776 11.8859 0.0473646 12.4273 0.342666 12.8703L4.79679 19.613V21.3848C4.79679 21.7047 5.09209 22 5.412 22H13.0652C13.3851 22 13.6804 21.7047 13.6804 21.3848V19.0224L14.9601 16.66C15.1569 16.2416 15.28 15.8233 15.28 15.3803V9.72038C15.28 8.63761 14.4925 7.82553 13.459 7.72709ZM14.0496 15.3803C14.0496 15.6264 13.9757 15.8725 13.8773 16.094L12.4746 18.5794C12.4254 18.6532 12.4008 18.7763 12.4008 18.8747V20.7696H6.02721V19.4407C6.02721 19.3177 5.978 19.1946 5.95339 19.1208L1.30239 12.2304C1.17935 12.0582 1.13014 11.8613 1.17935 11.6398C1.22857 11.566 1.25318 11.3445 1.47465 11.2215C1.54848 11.1723 1.79456 11.0246 2.45899 11.5414L3.49254 12.4519C3.68941 12.6242 3.78785 12.8703 3.78785 13.0671V13.5347C3.78785 13.8546 4.08315 14.1499 4.40306 14.1499C4.72297 14.1499 5.01827 13.8546 5.01827 13.5347V12.4519V11.7137V4.06044C5.01827 3.88818 5.09209 3.74053 5.21513 3.61749C5.33818 3.49444 5.51044 3.42062 5.7073 3.44523C6.02721 3.44523 6.32251 3.76514 6.32251 4.18348V6.39824V7.80092V10.7047C6.32251 11.0246 6.61782 11.3199 6.93773 11.3199C7.25764 11.3199 7.55294 11.0246 7.55294 10.7047V7.82553C7.55294 7.65327 7.62676 7.50562 7.7498 7.38258C7.87285 7.25953 8.0451 7.18571 8.24197 7.21032C8.56188 7.21032 8.85718 7.53023 8.85718 7.94857V8.12083V8.613V10.8031C8.85718 11.1231 9.15248 11.4184 9.47239 11.4184C9.7923 11.4184 10.0876 11.1231 10.0876 10.8031V8.613C10.0876 8.44074 10.1614 8.24387 10.2845 8.12083C10.4075 7.99779 10.5798 7.92396 10.7766 7.94857C11.0965 7.94857 11.3919 8.26848 11.3919 8.68682V8.98212V9.76959V11.6398C11.3919 11.9597 11.6872 12.255 12.0071 12.255C12.327 12.255 12.6223 11.9597 12.6223 11.6398V9.76959C12.6223 9.59733 12.6961 9.44968 12.8191 9.32664C12.9422 9.2036 13.1144 9.12977 13.3113 9.15438C13.6312 9.15438 13.9265 9.47429 13.9265 9.89264L14.0496 15.3803Z' fill='%23787983'/%3E%3Cpath d='M9.02955 5.41385C9.34946 5.48768 9.69398 5.2416 9.76781 4.92169C9.81702 4.62638 9.84163 4.3803 9.84163 4.085C9.86624 1.82102 8.04521 0 5.75663 0C3.46805 0 1.67163 1.82102 1.67163 4.085C1.67163 4.79864 1.8685 5.48768 2.21302 6.10289C2.33606 6.29976 2.53293 6.4228 2.7544 6.4228C2.87744 6.4228 2.95127 6.37358 3.0497 6.34897C3.345 6.17672 3.46805 5.80759 3.29579 5.51229C3.0497 5.09394 2.92666 4.60178 2.92666 4.10961C2.92666 2.53467 4.2063 1.25503 5.78124 1.25503C7.35618 1.25503 8.63582 2.53467 8.63582 4.10961C8.63582 4.30648 8.63582 4.47873 8.5866 4.70021C8.46356 5.04473 8.66043 5.36464 9.02955 5.41385Z' fill='%23787983'/%3E%3C/svg%3E");
        background-size: cover;
        background-repeat: no-repeat;
        display: inline-block;
        content: '';
        width: 16px;
        height: 22px;
        margin-inline-end: 12px;
    }
    .question-video__hold-button:hover:before
    {
        border-color: #979797;
    }

    .question-video__hold-button.button:active {
        background: rgba(0, 0, 0, 0.07);
    }


    .question-video__bar
    {
        margin-top: 18px;
    }

    @keyframes question-video-ripple
    {
        from { opacity: 0.2; }
        to {
            opacity: 0;
            transform: scale(10);
        }
    }
`;
